// extracted by mini-css-extract-plugin
export default {"title":"team-module--title--lq6fw","teamTitle":"team-module--teamTitle--NCKpR","fire":"team-module--fire--c56is"};